import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import FadeIn from './FadeIn';

const CallToAction: React.FC = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  return (
    <section className="relative py-24 overflow-hidden">
      {/* Background with smooth gradient */}
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-brand-blue via-[#4b82ff] to-brand-purple"></div>

      {/* Minimalist Decor */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-white/10 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-brand-dark/20 rounded-full blur-[80px] translate-y-1/3 -translate-x-1/4"></div>

      <div className="container mx-auto px-4 md:px-8 relative z-10 text-center">
        <FadeIn>
          <div className="inline-flex items-center gap-2 px-6 py-2.5 bg-white rounded-full text-brand-blue font-bold text-sm mb-8 shadow-lg shadow-brand-blue/20">
            <Sparkles size={18} />
            <span>{t('about.ctaSubtitle', t('home.ctaSubtitle'))}</span>
          </div>

          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 tracking-tight leading-tight">
            {t('about.ctaTitle', t('home.ctaTitle')).split('\n')[0]} <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-white via-blue-100 to-blue-200">
              {t('about.ctaTitle', t('home.ctaTitle')).split('\n')[1] || t('about.ctaTitle', t('home.ctaTitle')).replace('Bir Sonraki', '')}
            </span>
          </h2>

          <p className="text-blue-50 max-w-2xl mx-auto mb-12 text-lg leading-relaxed font-medium opacity-90">
            {t('about.ctaDesc', t('home.ctaDesc'))}
          </p>

          <div className="flex flex-col sm:flex-row gap-5 justify-center items-center">
            <button
              onClick={() => navigate(i18n.language === 'en' ? '/en/contact' : '/iletisim')}
              className="group bg-white text-brand-blue px-8 py-4 rounded-xl font-bold text-lg hover:bg-blue-50 hover:scale-105 hover:shadow-xl hover:shadow-black/10 transition-all duration-300 flex items-center justify-center gap-2 w-full sm:w-auto min-w-[200px]"
            >
              {t('about.ctaStart', t('home.ctaStart'))}
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              onClick={() => navigate(i18n.language === 'en' ? '/en/projects' : '/projelerimiz')}
              className="px-8 py-4 rounded-xl font-bold text-lg bg-[#353589] text-white hover:bg-[#2a2a6b] hover:scale-105 hover:shadow-xl hover:shadow-black/10 transition-all duration-300 w-full sm:w-auto min-w-[200px]"
            >
              {t('about.ctaReferences', t('home.ctaReferences'))}
            </button>
          </div>
        </FadeIn>
      </div>
    </section>
  );
};

export default CallToAction;